import type { ExtrasGroup } from "@@/shared/acquire/extras-group";

const checkExtrasConditions = (
    extra: ExtrasGroup,
    options: { onPremise: boolean },
) => {
    return extra.conditions?.every(condition => {
        if (condition.type === "EXTRAS_CONDITION_ONLY_ON_PREMISE") {
            return options.onPremise;
        }
        return true;
    });
};

export { checkExtrasConditions };
